export default __webpack_public_path__ + "static/media/ApprovalIcon.637102da.svg";